import { render } from "./FavoriteIcon.vue?vue&type=template&id=6ed63aeb"
import script from "./FavoriteIcon.vue?vue&type=script&lang=js"
export * from "./FavoriteIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__